module.exports = __webpack_public_path__ + "media/cortina/guia-izq-alapared-ac039327.png";